import React, { memo } from "react";
import {
  SquaresFour, GraduationCap, Users, UserCheck, ClipboardText, ArrowsClockwise,
  BookOpen, Calendar, Ticket, ChatCircleText, Star, DownloadSimple, Plus, PaperPlaneTilt,
  Check, X, MagnifyingGlass, Bell, Gear, WarningCircle, UserPlus, Lock, SignOut,
  PencilSimple, Trash, Copy, Shield, CreditCard, FileText, ChartBar, CaretDown,
  CaretRight, CaretUp, House, Heart, Baby, ForkKnife, Moon, Pulse, Pill,
  Sparkle, Smiley, Note, Eye, Funnel, ArrowRight, ArrowLeft, Clock, Upload,
  Camera, Phone, EnvelopeSimple, MapPin, Buildings, Stethoscope, Checks,
  UserMinus, Tray, Hourglass, CheckCircle, ArrowCounterClockwise,
  Megaphone, CaretLeft, SunDim, CloudSun, Question
} from "@phosphor-icons/react";

const iconMap = {
  // Sidebar navigation
  dashboard: SquaresFour, classrooms: BookOpen, students: GraduationCap, attendance: UserCheck,
  "daily-log": ClipboardText, coverage: ArrowsClockwise, teachers: Users, schedule: Calendar,
  tickets: Ticket, messages: ChatCircleText, events: Star, billing: CreditCard,
  enrollment: FileText, reports: ChartBar, audit: Shield, users: UserPlus,
  // Actions
  download: DownloadSimple, plus: Plus, send: PaperPlaneTilt, check: Check, x: X, search: MagnifyingGlass,
  bell: Bell, school: GraduationCap, settings: Gear, alert: WarningCircle, lock: Lock,
  logout: SignOut, edit: PencilSimple, trash: Trash, copy: Copy, home: House, help: Question, calendar: Calendar,
  heart: Heart, baby: Baby, eye: Eye, filter: Funnel, clock: Clock,
  upload: Upload, camera: Camera, phone: Phone, mail: EnvelopeSimple, "map-pin": MapPin,
  building: Buildings, stethoscope: Stethoscope, "file-check": Checks,
  "chevron-down": CaretDown, "chevron-right": CaretRight, "chevron-up": CaretUp,
  chevronLeft: CaretLeft,
  "arrow-right": ArrowRight, "arrow-left": ArrowLeft, activity: Pulse,
  // Daily activity log types
  meal: ForkKnife, nap: Moon, diaper: Baby, learning: BookOpen,
  medicine: Pill, milestone: Star, mood: Smiley, note: Note,
  // Weather/time
  sun: SunDim, "cloud-sun": CloudSun, moon: Moon,
};

const Icon = memo(({ name, size = 20, color }) => {
  const Comp = iconMap[name];
  if (!Comp) return null;
  return color ? <Comp size={size} weight="regular" color={color} /> : <Comp size={size} weight="regular" />;
});

export default Icon;

export {
  SquaresFour as LayoutDashboard,
  GraduationCap, Users, UserCheck, ClipboardText as ClipboardList,
  ArrowsClockwise as RefreshCw, BookOpen, Calendar, Ticket,
  ChatCircleText as MessageSquare, Star, DownloadSimple as Download,
  Plus, PaperPlaneTilt as Send, Check, X, MagnifyingGlass as Search,
  Bell, Gear as Settings, WarningCircle as AlertCircle, UserPlus, Lock,
  SignOut as LogOut, PencilSimple as Pencil, Trash as Trash2, Copy,
  Shield, CreditCard, FileText, ChartBar as BarChart3, CaretDown as ChevronDown,
  CaretRight as ChevronRight, CaretUp as ChevronUp, House as Home,
  Heart, Baby, ForkKnife as Utensils, Moon, Pulse as Activity, Pill, Sparkle as Sparkles,
  Smiley as Smile, Note as StickyNote, Eye, Funnel as Filter,
  ArrowRight, ArrowLeft, Clock, Upload, Camera, Phone,
  EnvelopeSimple as Mail, MapPin, Buildings as Building, Stethoscope,
  Checks as FileCheck, UserMinus as UserX, Tray as Inbox, Hourglass,
  CheckCircle, ClipboardText as ClipboardCheck, ArrowCounterClockwise as Undo2, Megaphone
};
